import { Injectable, inject } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  private readonly authService = inject(AuthenticationService);
  private readonly router = inject(Router);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('AuthGuard.canActivate called');
    return this.checkAuth(state.url);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('AuthGuard.canActivateChild called');
    return this.checkAuth(state.url);
  }

  canLoad(
    route: any,
    _segments: any[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('AuthGuard.canLoad called');
    const url = `/${route.path}`;
    return this.checkAuth(url);
  }

  private async checkAuth(url: string): Promise<boolean | UrlTree> {
    await this.authService.initialize();

    const isAuthenticated = this.authService.isAuthenticated();
    console.log('AuthGuard.checkAuth - isAuthenticated:', isAuthenticated);
    console.log('AuthGuard.checkAuth - requested URL:', url);

    if (!isAuthenticated) {
      console.log('AuthGuard redirecting to login with returnUrl:', url);

      return this.router.createUrlTree(['/login'], {
        queryParams: { returnUrl: url }
      });
    }

    console.log('AuthGuard allowing access');
    return true;
  }
}
